"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sectors = void 0;
const sectorsGetSectorLocationSectorsSectorLocationGet_js_1 = require("../funcs/sectorsGetSectorLocationSectorsSectorLocationGet.js");
const sectorsGetSectorPostcodeLocationSectorsSectorPostcodeLocationGet_js_1 = require("../funcs/sectorsGetSectorPostcodeLocationSectorsSectorPostcodeLocationGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Sectors extends sdks_js_1.ClientSDK {
    /**
     * Get Sector Location
     *
     * @remarks
     * Get location data for a sector.
     */
    async getSectorLocationSectorsSectorLocationGet(security, sector, options) {
        return (0, fp_js_1.unwrapAsync)((0, sectorsGetSectorLocationSectorsSectorLocationGet_js_1.sectorsGetSectorLocationSectorsSectorLocationGet)(this, security, sector, options));
    }
    /**
     * Get Sector Postcode Location
     *
     * @remarks
     * Get postcode location data for postcodes inside of a sector.
     */
    async getSectorPostcodeLocationSectorsSectorPostcodeLocationGet(security, sector, options) {
        return (0, fp_js_1.unwrapAsync)((0, sectorsGetSectorPostcodeLocationSectorsSectorPostcodeLocationGet_js_1.sectorsGetSectorPostcodeLocationSectorsSectorPostcodeLocationGet)(this, security, sector, options));
    }
}
exports.Sectors = Sectors;
//# sourceMappingURL=sectors.js.map